import React, { createContext, useContext, useReducer } from 'react';
import reducer from './reducer';

export const initialState = {
  auth: null,
  authState: '',
  defaultOrganisation: {},
  employee: null,
  user: '',
  V2Token: '',
  V2DispatcherToken: '',
}

export const AuthStateContext = createContext();
export const AuthDispatchContext = createContext();

function AuthContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState)
  return (
    <AuthStateContext.Provider value={state}>
      <AuthDispatchContext.Provider value={dispatch}>
        {children}
      </AuthDispatchContext.Provider>
    </AuthStateContext.Provider>
  )
}

function useAuthDispatch() {
  const context = useContext(AuthDispatchContext)
  if (context === undefined) {
    throw new Error('useAuthDispatch must be used within a AuthState Provider')
  }
  return context
}

function useAuthState() {
  const context = useContext(AuthStateContext)
  if (context === undefined) {
    throw new Error('useAuthState must be used within a AuthSate Provider')
  }
  return context
}

export { AuthContext, useAuthDispatch, useAuthState };